import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';

@Injectable()
export class ChargesService {
    private baseApiUrl: string;

    constructor (configurationService: ConfigurationService, private httpClient: HttpClient) {
        this.baseApiUrl = configurationService.BaseApiUrl;
    }

    getFiltered(filter: string, pageIndex: number, pageSize: number,
      sortColumn: string, sortAscending: boolean, isMaintenance: boolean = false): Observable<any> {

      const params = {
        filter, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance
      };

      return this.httpClient.post(this.baseApiUrl + 'charges/filter', params).pipe(
        map((res: any) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    getAll(forMaintenance: boolean = false): Observable<any> {
       return this.httpClient.get(this.baseApiUrl + `charges?isMaintenance=${forMaintenance}`).pipe(
        map((res: any) =>  res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    getById(id: number, forMaintenance: boolean = false): Observable<any> {
      return this.httpClient.get(this.baseApiUrl + `charges/${id}?isMaintenance=${forMaintenance}`).pipe(
        map((res: Response) => this.addLedgerDisplayData(res)),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    getByCode(code: string): Observable<any> {
      return this.httpClient.get(this.baseApiUrl + `charges/code/${code}`).pipe(
        map((res: Response) => this.addLedgerDisplayData(res)),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    getByChargesId(moduleId: number):  Observable<any> {
      return this.httpClient.get(this.baseApiUrl + `charges/application/${moduleId}`).pipe(
        map((res: Response) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    create(charges: any): Observable<any> {
      return this.httpClient.post(this.baseApiUrl + `charges`, charges).pipe(
        map((res: Response) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    update(charges: any): Observable<any> {
      return this.httpClient.put(this.baseApiUrl + `charges`, charges).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    authorise(id: number): Observable<any> {
      return this.httpClient.post(this.baseApiUrl + `charges/authorise`, id).pipe(
        map((res: Response) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    delete(id: number): Observable<any> {
      return this.httpClient.delete(this.baseApiUrl + `charges/${id}`).pipe(
        map((res: Response) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    addLedgerDisplayData(ledger: any): any {
      ledger.displayData = `${ledger.description} - ${ledger.code}`;
    return ledger;
    }

    getBySchemeChargeId(id: number, forMaintenance: boolean = false): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `charge/scheme/${id}?isMaintenance=${forMaintenance}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }
  }
